var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5835 14.25H7.12516V15.8333H1.5835V14.25ZM1.5835 8.70829H8.7085V10.2916H1.5835V8.70829ZM1.5835 3.16663H17.4168V4.74996H1.5835V3.16663ZM16.3671 10.3114L17.2822 10.0019L18.0739 11.373L17.3487 12.0103C17.44 12.4431 17.44 12.8902 17.3487 13.3229L18.0739 13.9602L17.2822 15.3314L16.3671 15.0218C16.0425 15.3148 15.6562 15.5404 15.231 15.6789L15.0418 16.625H13.4585L13.2685 15.6781C12.8483 15.5408 12.4616 15.317 12.1332 15.021L11.2181 15.3314L10.4264 13.9602L11.1516 13.3229C11.0603 12.8902 11.0603 12.4431 11.1516 12.0103L10.4264 11.373L11.2181 10.0019L12.1332 10.3114C12.4578 10.0185 12.8442 9.79288 13.2693 9.65433L13.4585 8.70829H15.0418L15.2318 9.65513C15.6562 9.79288 16.0425 10.0193 16.3671 10.3122V10.3114ZM14.2502 14.25C14.6701 14.25 15.0728 14.0831 15.3697 13.7862C15.6667 13.4893 15.8335 13.0866 15.8335 12.6666C15.8335 12.2467 15.6667 11.844 15.3697 11.547C15.0728 11.2501 14.6701 11.0833 14.2502 11.0833C13.8302 11.0833 13.4275 11.2501 13.1306 11.547C12.8336 11.844 12.6668 12.2467 12.6668 12.6666C12.6668 13.0866 12.8336 13.4893 13.1306 13.7862C13.4275 14.0831 13.8302 14.25 14.2502 14.25Z",
    fill: "#343741"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7989431b2284609aab2d216bc9334b0b.svg";
export { ForwardRef as ReactComponent };